import $ from 'jquery';
import moment from 'moment';
import _ from 'underscore';
import chartjs from 'chart.js/dist/Chart.bundle';
// a hack to make $ and moment available for datepicker and other jquery plugins
export default ((window.$ = window.jQuery = $),
(window.moment = moment),
(window.chartjs = chartjs),
(window.underscore = _));
